@if (visible$ | async) {
    <div class="row mb-3">
        <p class="col-sm-10 col-12" [innerHTML]="(checkpoint$ | async)?.label"></p>
        <label [attr.for]="(checkpoint$ | async)?.xmlId" class="col-sm-2 col-12 text-end filter-text">
            {{ checkpointTypeLabel$ | async }}
        </label>
    </div>
    <div class="mb-3">
        <fieldset [id]="(checkpoint$ | async)?.xmlId" [formGroup]="radioGroup" class="row justify-content-between">
            <div class="col-auto col-sm-6 d-flex flex-column flex-sm-row gap-2">
                @for (option of options$ | async; track trackByFn($index, option)) {
                    <span class="options">
                        <pace-forms-input-radio
                            [label]="radioButtonLabels[option.optionType]"
                            [value]="option.optionType"
                            [name]="option.xmlId"
                            [formControl]="radioControl"
                        ></pace-forms-input-radio>
                    </span>
                }
            </div>
            <div class="col-auto col-sm-5 align-self-end pe-0">
                @if ((readOnly$ | async) === false) {
                    <button
                        class="btn btn-link"
                        (click)="reset()"
                        translate="F4M_CHECKPOINT_RESET_BUTTON_LABEL"
                    ></button>
                }
            </div>
        </fieldset>
    </div>
}
